export default __webpack_public_path__ + "static/terracina-broomfield-apartments-pool-132bfd1acb3caf0c1e9fa15c6fd13d93.jpg";